import React from 'react';
import KpiCard, { KpiCardProps } from '../../../../../components/KpiCard';

export default function CardStats(props: KpiCardProps) {
    return <KpiCard {...props} />;
}

